import { IRolesDTO } from './roles.dao';
import { IPaginationParams } from './shared.dto';
abstract class IUserGroupsDAO {
    public abstract getUserGroups(params: IPaginationParams & {accountId: number}): Promise<IUserGroupsListDTOInternal>;
    public abstract getUserGroup(params: { userGroupId: number; accountId: number}): Promise<IUserGroupDTO>;
    public abstract editGroup(params: IUserGroupDTO & { accountId: number}): Promise<IUserGroupDTO>;
    public abstract createGroup(params: IUserGroupCreateDTO & { accountId: number}): Promise<IUserGroupDTO>;
    public abstract deleteGroup(params: {userGroupId: number} & { accountId: number}): Promise<void>;
}



interface IUserDTO {
    firstName: string;
    lastName: string;
    username: string;
    active?: boolean;
}



interface IUserGroupDTO {
    userGroupId: number;
    name: string;
    description: string;
    users: IUserDTO[];
}

type IUserGroupCreateDTO = Omit<IUserGroupDTO, 'userGroupId'>;

interface IUserGroupsListDTOInternal {
    content: IUserGroupDTO[];
    totalElements: number;
}


interface IUserDetailsDTO extends IUserDTO {
    roles: IRolesDTO[];
    username: string;
}


export {
    IUserGroupsListDTOInternal,
    IUserGroupCreateDTO,
    IUserGroupsDAO,
    IUserDTO,
    IUserGroupDTO,
    IUserDetailsDTO,
};
